exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-style {\n  color: #000000;\n  font-family: 'Shadows Into Light', cursive;\n}\n\n.header-link {\n  color: #000;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.header-link:hover {\n  text-shadow: 2px 2px 2px rgba(78, 78, 78, 0.6);\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n.header-block {\n  margin-bottom: 150px;\n  padding: 0 0 0 20px;\n}\n\n.social-icons-block {\n  margin-top: 20px;\n  width: 200px;\n}\n\n.social-icons-list {\n  list-style-type: none;\n  padding: 0;\n}\n\n.social-icons-list li {\n  float: left;\n  width: 33%;\n}\n\n.social-icons-list li img {\n  border: 1px solid #000000;\n  border-radius: 3px;\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n  width: 45px;\n}\n\n.social-icons-list li img:hover {\n  border-radius: 50px;\n  -webkit-box-shadow: 2px 2px 10px rgba(78, 78, 78, 0.6);\n          box-shadow: 2px 2px 10px rgba(78, 78, 78, 0.6);\n  -webkit-transition: 0.5s;\n  transition: 0.5s;\n}\n\n/* responsive styles */\n\n@media screen and (max-width: 550px) {\n  .header-block {\n    padding: 0 0 0 10px;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/abeltrotter/Documents/git/epicodus/javascript/portfolio-angular/src/app/header/header.component.css
// module id = ../../../../../src/app/header/header.component.css
// module chunks = main